import links from './links'


const getProjectName = (state) => {
  const { routing: { locationBeforeTransitions: { pathname } } } = state

  return Object.keys(links).find((project) => {
    const projectLinks = links[project]

    return Object.keys(projectLinks).some((key) => {
      const _links = projectLinks[key]

      if (typeof _links === 'string') {
        return pathname.includes(_links)
      }

      return Object.keys(_links).some((key) => pathname.includes(_links[key]))
    })
  })
}


export default getProjectName
